/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  CREATE_GROUP,
  EDIT_GROUP,
  GET_GROUP_FOR_ID,
  IS_EDIT,
  SET_LIST_ALL_GROUP,
  UNSET_CREATE_GROUP,
  UNSET_EDIT_GROUP,
} from '~/actions/actionTypes';

const initialState: reducers.GroupReducer = {
  myGroups: [],
  countGroup: 0,
  hasCreateGroup: false,
  hasEditGroup: false,
  showGroup: null,
  isEdit: null,
};

const groupReducer = (state = initialState, action: any) => {
  const { payload } = action;

  switch (action.type) {
    case SET_LIST_ALL_GROUP:
      state = {
        ...state,
        myGroups: payload.rows,
        countGroup: payload.count,
      };
      break;

    case CREATE_GROUP:
      state = {
        ...state,
        hasCreateGroup: true,
      };
      break;

    case IS_EDIT:
      state = {
        ...state,
        isEdit: payload,
      };
      break;

    case EDIT_GROUP:
      state = {
        ...state,
        hasEditGroup: true,
      };
      break;

    case GET_GROUP_FOR_ID:
      state = {
        ...state,
        showGroup: payload,
      };
      break;

    case UNSET_CREATE_GROUP:
      state = {
        ...state,
        hasCreateGroup: false,
      };
      break;

    case UNSET_EDIT_GROUP:
      state = {
        ...state,
        hasEditGroup: false,
      };
      break;
    default:
      return state;
  }

  return state;
};

export default groupReducer;
